export default {"src":"/_next/static/media/pdf_40.d164d38e.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};